// tags.ts
export const tags: string[] = [
  'Food',
  'Drink',
  'Restaurant',
  'Bar',
  'Bistro',
  'Diner',
  'Pub',
  'Lounge',
  'Bubble Tea',
  'Coffee',
  'Tea',
  'Smoothies',
  'Vegan',
  'Vegetarian',
  'Gluten-Free',
  'Halal',
  'Organic',
  'Farm-to-Table',
  'Breakfast',
  'Brunch',
  'Lunch',
  'Dinner',
  'Late Night',
  'Desserts',
  'Ice Cream',
  'Bakery',
  'Pastries',
  'Pizza',
  'Burgers',
  'Tacos',
  'Noodles',
  'Ramen',
  'Sushi',
  'BBQ',
  'Seafood',
  'Grill',
  'Sandwiches',
  'Salads',
  'Juice Bar',
  'Food Truck',
  'Takeout',
  'Delivery',
  'Outdoor Seating',
  'Pet-Friendly',
  'Café',
  'Casual Dining',
  'Fine Dining',
  'All-Day Breakfast',
  'Live Music',
  'Trivia Night',
  'Karaoke',
  'Board Games',
  'Open Mic',
  'Art Shows',
  'Workshops',
  'Pop-Up Market',
  'Themed Events',
  'Dance Nights',
  'Indian',
  'Chinese',
  'Japanese',
  'Italian',
  'Mexican',
];
